<template>
  <div
    data-cy="addressDisplayHeader"
    class="primary-text">
    {{ bltHeader }}
  </div>
  <div
    data-cy="addressDisplayLineOne"
    class="secondary-text"
    v-if="bltAddress">
    {{ bltAddress.address1 }}
  </div>
  <div
    data-cy="addressDisplayLineTwo"
    class="secondary-text"
    v-if="bltAddress">
    {{ bltAddress.address2 }}
  </div>
  <div
    data-cy="addressDisplayLineOne"
    class="secondary-text"
    v-if="addressConfirmation">
    {{ addressConfirmation.street1 }}
  </div>
  <div
    data-cy="addressDisplayLineTwo"
    class="secondary-text"
    v-if="addressConfirmation">
    {{ addressConfirmation.street2 }}
  </div>
  <div
    data-cy="addressDisplayCityStateZip"
    class="secondary-text"
    v-if="bltAddress || addressConfirmation">
    {{ displayCityStateZipValue }}
  </div>
  <div
    data-cy="addressDisplayCountryCode"
    class="secondary-text"
    v-if="bltAddress && showCountryCode">
    {{ bltAddress.countryCode }}
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from 'vue'
import type AddressConfirmation from '@/common/data/AddressConfirmation'
import {$inj} from '@/common/decorators/depinject.ts'
import BltAddressText from '@/common/services/filters/bltAddressText.ts'

export default defineComponent({
  name: 'bltAddress',
  setup() {
    return {
      bltAddressText: $inj(BltAddressText)
    }
  },
  props: {
    showCountryCode: Boolean,
    bltHeader: String,
    bltAddress: {
      type: Object as PropType<{
        address1: string
        address2?: string
        city?: string
        state?: string
        zipCode?: string
        countryCode?: string
      }>
    },
    addressConfirmation: {
      type: Object as PropType<AddressConfirmation>
    }
  },
  computed: {
    displayCityStateZipValue() {
      return this.bltAddressText.format(
        this.bltAddress?.city ?? this.addressConfirmation?.city,
        this.bltAddress?.state ?? this.addressConfirmation?.stateProvince,
        this.bltAddress?.zipCode ?? this.addressConfirmation?.zipCode
      )
    }
  }
})
</script>
